<template>
    <view-an-experimental-dataset-component :currentExperimentalDataset="currentExperimentalDataset" @back="handleBack" @uploadExperimentalDataset="handleUploadExperimentalDataset" @viewData="handleViewData" :assesmentMethods="assesmentMethods" :currentValidationPlanTemplate="currentValidationPlanTemplate" :currentExperimentalPlan="currentExperimentalPlan" @submitArchivedExperimentalDataset="handleSubmitArchivedExperimentalDataset" :validationParameters="validationParameters"></view-an-experimental-dataset-component>
</template>

<script>
import ViewAnExperimentalDatasetComponent from '@/components/dataset/ViewAnExperimentalDatasetComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
    name: 'ViewAnExperimentalDataset',
    components: {ViewAnExperimentalDatasetComponent},
    data: function () {
        return {
            component_url: 'experiments/datasets/',
            currentExperimentalDataset: {},
            currentExperimentalPlan: {},
            currentValidationPlanTemplate: {},
            assesmentMethods:[],
        }
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentExperimentalDatasetID', 'auth_header',
            'validationParameters','mathservice_start_date'
        ])
    },

    mounted: function() {
        this.setBreadcrumb();
        if (this.$route.params.id) {
            this.currentExperimentalDataset.id = this.$route.params.id;      
        }
        else {
            console.log("OpenExperimentalDataset view no router params.id")
            this.currentExperimentalDataset.id = this.currentExperimentalDatasetID
        }        
           
        //set ExperimentalDataset id in vuex
        this.setExperimentalDatasetId()
        this.getExperimentalDataset();   
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXPERIMENTAL_DATASET_ID', 'CHANGE_EXPERIMENTAL_DATA_OBJECT'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global ExperimentalDatasetId
        setExperimentalDatasetId: function(){
            this.CHANGE_EXPERIMENTAL_DATASET_ID(this.currentExperimentalDataset.id)
        },
        getExperimentalDataset: function(){
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentExperimentalDataset.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalDataset = response.data;

                    let createdMoment = moment(this.currentExperimentalDataset.created_at);
                    let isNew = createdMoment.isAfter(moment(this.mathservice_start_date));
                    if(isNew){
                        console.log("is new, redirecting");
                        this.$router.replace({ name: "ViewDataset", params: {id: this.currentExperimentalDataset.id} });
                    } else {
                        this.currentExperimentalPlan.id = response.data.experimental_plan.id
                        this.getExperimentalPlan()
                    }

                })
                .catch(error => {
                    console.log("Something went wrong getting the current Dataset", error);
                });
        },
        getExperimentalPlan: function(){ 
            axios
                .get(
                    this.base_url+ 'experiments/plans/' +
                    this.currentExperimentalPlan.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalPlan = response.data;                    
                    this.getValidationPlanTemplate()
                })
                .catch(error => {
                    console.log("Something went wrong getting the current Experimental Plan in Dataset", error);
                });
        },
        getValidationPlanTemplate: function(){ 
            axios
                .get(
                    this.base_url+ 'experiments/templates/' +this.currentExperimentalPlan.template.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentValidationPlanTemplate = response.data;
                    
                    var mainThis = this                    
                    response.data.assessment_methods.forEach(function(method, i) {
                        mainThis.getAssesmentMethod(method, response.data)
                    })
                    
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ValidationPlanTemplate", error);
                });
                
        },
        getAssesmentMethod: function(method, currentValidationPlanTemplate){
            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    meth.criteria =[]
                    var mainThis = this
                    // loop criteria and add to the method
                    currentValidationPlanTemplate.criteria.forEach(function(item, index, array) {
                        if(item.assessment_method==method){
                            meth.criteria.push(item)
                        }
                    })

                    // sort criteria array
                    meth.criteria.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        
                        // names must be equal
                        return 0;
                    });

                    // Add assMeth to the array
                    this.assesmentMethods.push(meth)

                    //sort assesment method array
                    this.assesmentMethods.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        
                        // names must be equal
                        return 0;
                    });
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },

        handleUploadExperimentalDataset: function(currentExperimentalDataset) {
            this.$router.push({ name: "UploadExperimentalDataset", params: { id: currentExperimentalDataset.id } });
        },
        handleBack: function() {
            this.$router.push({ name: "ViewAllExperimentalDatasets", params: {} });
        },
        handleViewData: function(assesmentMethodId){
            var viewDataObject = {
                assesment_method_id: assesmentMethodId,
                experimental_dataset_id: this.currentExperimentalDataset.id
            }

            axios
                .head(this.base_url+ this.component_url + this.currentExperimentalDataset.id + '/assessments/' + assesmentMethodId + '/input/',
                {
                    headers: this.auth_header
                })
                .then((response) => {
                    // check if there is Data
                    if(response.headers['content-length']==2){
                        this.loading = false;
                        this.$toast.open({
                            duration: 500,
                            message: `No Data to show! Upload dataset`,
                            position: 'is-top',
                            type: 'is-danger'
                        })
                    } 
                    else if (response.headers['content-length']>2) {                        
                        this.setExperimentalDataObject(viewDataObject)
                        this.$router.push({ name: "ViewExperimentalData", params: { obj: viewDataObject } });
                    }
                })
                .catch((error) => {
                    console.log('head request error: ', error)
                }); 
        },
        //set global ExperimentalDataobject
        setExperimentalDataObject: function(currentExperimentalDataObj){
            this.CHANGE_EXPERIMENTAL_DATA_OBJECT(currentExperimentalDataObj)
        },
        handleSubmitArchivedExperimentalDataset: function(experimentalDataset) {
            axios
                .patch(`${this.base_url}${this.component_url}${experimentalDataset.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header 
                    }
                )
                .then(response => {
                    console.log("Experimental Dataset Successfully Archived:", experimentalDataset);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Dataset Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ViewAllExperimentalDatasets", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Dataset was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Experimental Dataset was not successfully Edited: ", error.response.data);
                });
        },
    }
}
</script>

